<template>
  <!-- Modal -->
  <div>
  <div class="modal fade" :id="modal_id">
    <div :class="size" class="modal-dialog modal-dialog-centered">
      <form @submit.prevent="whatsMethod" class="modal-content" :class="class_form">
        <div :style="style_top_header">
          <div v-if="header" :class="class_header"  :style="style_header" class="modal-header bg-white cursor-default">
            <h5 class="modal-title px-2" style="display: flow-root;">
              <div class="d-flex">
              <span class="d-flex">
                <div @click.prevent="showLead(lead_id)" :class="lead_id ? 'cursor_pointer' : ''" class="title-color">
                   <span v-if="icon">
                      <i :class='icon' class="mr-2"></i>
                   </span>
                  {{ modal_header }}
                </div>
                <div v-if="beta" class="pl-2 pt-0" style="margin-top: 0; font-size: .9rem;">
                  <span class="badge badge-danger rounded-0 font-weight-light">beta</span>
                </div>
              </span>
              </div>
            </h5>
            <button type="button" class="close pr-4" data-dismiss="modal" aria-label="Close">
              <span>&times;</span>
            </button>
          </div>
          <!-- Barra de opções - Modal showTicketModal -->
          <div v-if="($route.name === 'Home' && modal_id === 'showTicketModal') ||
                     ($route.name === 'ReportsTickets' && modal_id === 'showTicketModal') ||
                     ($route.name === 'Chat' && modal_id === 'showTicketModal') ||
                     ($route.name === 'Lead' && modal_id === 'showTicketModal') ||
                      ($route.name === 'Conversations' && modal_id === 'showTicketModal')"
               class="card-header bg-white">
            <div class="row">
              <div class="col-12 d-flex px-4">
                <div :class="tickets.ticket_view === 1 ? 'title-color font-weight-bold' : ''" @click.prevent="downScrollChat" class="pr-2 cursor_pointer">
                  <i class="bx bx-chat mr-2"></i> <small>{{ getTranslations('expression_546') }}</small>
                </div>
                <div v-if="this.$route.name !== 'Lead' && this.$route.name !== 'Chat'" :class="tickets.ticket_view === 2 ? 'title-color font-weight-bold' : ''" @click.prevent="tickets.ticket_view = 2" class="pl-4 cursor_pointer">
                  <i class="bx bx-user mr-2"></i> <small>{{ getTranslations('expression_34') }}</small>
                </div>
                <div :class="tickets.ticket_view === 3 ? 'title-color font-weight-bold' : ''" @click.prevent="tickets.ticket_view = 3" class="pl-4 ml-1 cursor_pointer">
                  <i class="bx bx-history mr-2"></i> <small>{{ getTranslations('expression_1078') }}</small>
                </div>
              </div>
            </div>
            <!--getLeadObject('id', tickets.ticket.lead_id).expiration &&-->
            <div v-if="modal_id === 'showTicketModal' &&
                      [0, 1, 2, 3, 4, 5, 11].includes(tickets.ticket.status_key) &&
                      tickets.ticket_view !== 2 &&
                      tickets.ticket_view !== 3 &&
                      (getChannelObject('id', tickets.ticket.channel_id) &&
                      getChannelObject('id', tickets.ticket.channel_id).integrations &&
                      getChannelObject('id', tickets.ticket.channel_id).integrations[9] &&
                      getChannelObject('id', tickets.ticket.channel_id).integrations[9].status_key)"
                 class="row border-top bg-light"
                 style="margin-left: -20px;
                        margin-right: -20px;">
              <div class="col-12 text-center">
                {{ getTranslations('expression_1199') }} {{ getLeadObject('id', tickets.ticket.lead_id).expiration ? getLeadObject('id', tickets.ticket.lead_id).expiration : '---' }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body" :style="style_body" :class="class_body">
          <slot name="body"></slot>
        </div>
        <div v-if="footer" :class="class_footer" :style="style_footer" class="modal-footer bg-white animated--grow-in">
          <slot name="footer"></slot>
        </div>
      </form>
    </div>
 
  </div>
  <ContactModal
  v-if="showContactModal"
  :key="contactModalKey"
  :lead="selectedLead"
  @close="closeContactModal"
/>
</div>
</template>

<script>
import $ from "jquery";
import {mapState} from "vuex";
import ContactModal from "../../views/ContactModal.vue";

export default {
  components: {
    ContactModal
  },
  name: "ModalDefault",
  data() {
    return {
      showContactModal: false,
      selectedLead: null
    }
  },
  props: [
      'modal_id',
      'size',
      'header',
      'class_body',
      'class_header',
      'class_footer',
      'style_header',
      'style_body',
      'style_footer',
      'modal_header',
      'style_top_header',
      'icon',
      'footer',
      'method',
      'beta',
      'lead_id',
      'class_form'
  ],
  computed: {
    ...mapState(['tickets']),
  },
  created() {

    // $('#showTicketModal').on('hidden.bs.modal', () => {
    //   this.tickets.ticket_view = 1
    // })
  },
  methods: {
    // showLead(payload){
    //   if (this.lead_id){
    //     window.localStorage.setItem("lead_id", payload)
    //     this.$store.dispatch("getLeadRedirect", payload)
    //     if(this.$route.name !== 'Lead'){
    //       setTimeout(() => {
    //         this.$router.push({name: 'Lead'})
    //       }, 500);
    //     }
    //     $(`#${this.modal_id}`).modal('hide')
    //     $(`#historyTicketModal`).modal('hide')
    //   } else {
    //     return
    //   }
    // },
    async showLead(leadId) {
    if (!leadId) return;

    try {
      this.showContactModal = false;
      this.selectedLead = null;
      
      
      await this.$store.dispatch("getLeadDetails", { id: leadId });
      
      this.selectedLead = this.$store.state.leads.lead;
      this.contactModalKey++; // Atualiza a chave APÓS carregar
      this.showContactModal = true;

      $(`#${this.modal_id}`).modal('hide');
      $(`#historyTicketModal`).modal('hide');
    } catch (error) {
      console.error("Erro ao carregar lead:", error);
    }
  },
  closeContactModal() {
    this.showContactModal = false;
    this.selectedLead = null;
  },
    whatsMethod(){
      if(this.method !== undefined) {
        this.method();
      }
    },
    downScrollChat() {
      this.tickets.ticket_view = 1; // set ticket
      setTimeout(() => {
        document.getElementById('chat_conversation').scrollIntoView({block: "end", behavior: "smooth"});
      }, 500);
    },
  }
}
</script>

<style scoped>
.modal-content {
  border-radius: 10px !important;
}
</style>
